import { Form, Formik } from "formik";
import { observer } from "mobx-react";
import * as React from "react";
import * as Yup from "yup";
import { t } from "../../i18n/util";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";
import { ErrorMessagesList, FormButtons } from "../ui/Primitives";
import { THEME } from "../../theme/ThemeStore";
import { JobCategoryEditDetailsGrid } from "./JobCategoryEditDetailsGrid";
import { JobCategoryCreatePayload } from "../../network/APITypes";

type Props = {
    onSubmit: (values: JobCategoryCreatePayload) => void;
    onBack: () => void;
};

export const JobCategoryEditDetailsForm = observer(({ onSubmit, onBack }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <Formik
            initialValues={{
                name: "",
                isActive: true,
                isDal: THEME.THEME_NAME === "dal",
                notificationUserEmails: [],
                primaryContactEmails: []
            }}
            validationSchema={Yup.object().shape({
                name: Yup.string().required(t("error.required"))
            })}
            onSubmit={onSubmit}
            validateOnChange
            validateOnBlur
            validateOnMount
        >
            {({ errors, touched, setFieldValue, values }) => (
                <Form style={{ height: "100%", flexGrow: 1 }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            flexWrap: "wrap",
                            height: "100%",
                            justifyContent: isMobile ? "flex-start" : "space-between"
                        }}
                    >
                        <div>
                            <JobCategoryEditDetailsGrid values={values} setFieldValue={setFieldValue} />
                        </div>

                        <ErrorMessagesList errors={errors} touched={touched} style={{ marginTop: 0 }} />
                        <FormButtons
                            labelBack={t("screen.details.button.back")}
                            labelSubmit={t("screen.applicantDetails.save")}
                            onBack={onBack}
                            style={{ marginTop: 20 }}
                        />
                    </div>
                </Form>
            )}
        </Formik>
    );
});

